import ReactTooltip from "react-tooltip";
import SearchSubheaderSvgComponent from "../../../assets/svg-components/sub-header/search";
import FilterSubheaderSvgComponent from "../../../assets/svg-components/sub-header/filter";
import ChangeOwnerSubheaderSvgComponent from "../../../assets/svg-components/sub-header/changeOwner";
import DownloadSubheaderSvgComponent from "../../../assets/svg-components/sub-header/download";
import LogSubheaderSvgComponent from "../../../assets/svg-components/sub-header/log";
import { getValue } from "@utils/lodash";
import CommonDateRange from "../DateRange";
import DatePicker from "react-datepicker";
import { Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { QueryRequestHelper } from "@_common/query-request-helper";
import BulkUploadDropdown from "@components/BulkUploadDropdown";
import BulkViewLogs from "@components/BulkUploadDropdown/bulk-logs";
import CalenderDropdown from "@_common/CalenderDropdown";
import CalendarViewSubheaderSvgComponent from "../../../assets/svg-components/sub-header/calendar-view";
import { NavLink } from "react-router-dom";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useCallback, useMemo, useState } from "react";
import { debounceSearch } from "@_common/common-helper";
import { CalendarDays, EllipsisVertical } from "lucide-react";
import { DownloadTypeEnum } from "@utils/general.enum";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function RightMenuHeaders(props: any) {
  const isApplyButtonRequied = props?.isApplyButtonRequied ?? true;
  const isYear = props.isYear ?? true;
  const isCompactActions = props.compactActions ?? false;

  // State for toggling Vendor Checkpoint sub-options on hover
  const [showCheckpointOptions, setShowCheckpointOptions] = useState(false);

  const urlParamsFun = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let request = QueryRequestHelper({ ...params });
    return request;
  };
  const mainQueryRequest = urlParamsFun();
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let compliance_task_ids: any = urlSearchParams.getAll(
    "compliance_task_ids[]",
  );
  const removeCalenderList = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let del: any = `compliance_task_ids[]`;
    delete params[del];
    if (getValue(props, `id`, "") === "id") {
      let queryRequest = QueryRequestHelper(params);
      let path = window.location.pathname.split("/list/id")[0];
      navigate(`${path}?${queryRequest}`);
    } else {
      let queryRequest = QueryRequestHelper(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  const handleChangeActiveStatusFilter = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (value === "all") {
      delete params.is_active;
    } else {
      params.is_active = value;
    }
    params.page_no = "1";
    let queryRequest = QueryRequestHelper(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const debouncedSearch = useMemo(
    () => debounceSearch(props.handleChangeSearch, 500),
    [],
  );

  const [searchText, setSearchText] = useState("");
  const yearStart = props.yearStart ?? 2000;
  const yearEnd = props.yearEnd ?? new Date().getFullYear() + 10;
  const years = useMemo(() => {
    const safeStart = Math.min(yearStart, yearEnd);
    const safeEnd = Math.max(yearStart, yearEnd);
    return Array.from({ length: safeEnd - safeStart + 1 }, (_, i) => safeStart + i);
  }, [yearStart, yearEnd]);

  const renderCalendarHeader = useCallback(
    ({
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled,
    }: any) => (
      <div
        style={{
          margin: "6px 8px 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
        }}
      >
        <button
          type="button"
          onClick={decreaseMonth}
          disabled={prevMonthButtonDisabled}
          style={{ border: 0, background: "transparent", cursor: "pointer", color: "#6b7280" }}
        >
          ‹
        </button>
        <div style={{ display: "flex", gap: 6 }}>
          <select
            value={date.getMonth()}
            onChange={({ target: { value } }) => changeMonth(Number(value))}
            style={{ height: 30, borderRadius: 4, border: "1px solid #d1d5db", padding: "0 8px" }}
          >
            {monthNames.map((month, index) => (
              <option key={month} value={index}>
                {month}
              </option>
            ))}
          </select>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(Number(value))}
            style={{ height: 30, borderRadius: 4, border: "1px solid #d1d5db", padding: "0 8px" }}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        <button
          type="button"
          onClick={increaseMonth}
          disabled={nextMonthButtonDisabled}
          style={{ border: 0, background: "transparent", cursor: "pointer", color: "#6b7280" }}
        >
          ›
        </button>
      </div>
    ),
    [years],
  );

  const handleChangeSearch = (e: any) => {
    console.log("search_value", e.target.value);
    setSearchText(e.target.value);
    debouncedSearch(e);
  };
  const handleApply = () => {
    const isPendingTask =
      getValue(props, "allTime", false) &&
      params.is_all_time === "true";

    const endOfCurrentMonth = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + 1,
      0
    );

    if (
      isPendingTask &&
      props.to_date &&
      new Date(props.to_date) > endOfCurrentMonth
    ) {
      toast.error(
        "Pending Tasks can only be filtered up to the current month."
      );
      return;
    }

    props.handleSubmitDate();
  };

  return (
    <>
      <div className=" d-flex align-items-center">
        {getValue(compliance_task_ids, `length`, 0) > 0 && (
          <div
            className="d-flex align-center"
            style={{
              backgroundColor: "#EFF5FE",
              padding: "5px",
              borderRadius: "5px",
              color: "rgb(26, 115, 232)",
              marginLeft: "10px",
              marginRight: "10px",
            }}
          >
            <h6 className="filter-form-wrappper__title">Calender List</h6>
            <img
              src="/images/close-red.svg"
              className="img-fluid cursor-pointer"
              height={20}
              width={20}
              onClick={removeCalenderList}
              style={{ marginLeft: "5px" }}
            />
          </div>
        )}
        {getValue(props, `allTime`, false) && (
          <div className=" d-flex align-items-center mx-2">
            <h4 className="header_text__blue">
              {window.location.pathname.includes("/repository/mapped-checkpoint/master")
                ? "All Time"
                : "All Pending Tasks"}
            </h4>
            <div className="choicelist-wrapper custom-switch-wrapper ms-2 mt-1">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={getValue(params, `is_all_time`, "") ? true : false}
                  onChange={() => props.handleCheckAlltime()}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        )}

        {getValue(props, `dateRange`, false) &&
          (getValue(props, `allTime`, false) ||
            getValue(props, `licenseStyleCalendar`, false) ? (

            <div
              className="d-flex align-items-end gap-2 flex-wrap"
              style={{
                borderRight: "1px solid #dadce0",
                visibility:
                  getValue(props, `allTime`, false) &&
                    params.is_all_time === "true"
                    ? "hidden"
                    : "visible",
              }}
            >

              {/* From Date */}
              <div className="d-flex flex-column">
                <label className="filter-label mb-1">From Date</label>

                <div className="right-menu-header-date-picker mb-1">
                  <DatePicker
                    renderCustomHeader={renderCalendarHeader}
                    selected={
                      props.from_date
                        ? new Date(props.from_date)
                        : null
                    }
                    onChange={(date: Date | null) => {
                      if (
                        date &&
                        props.to_date &&
                        new Date(date) > new Date(props.to_date)
                      ) {
                        toast.error(
                          "From Date cannot be greater than To Date"
                        );
                      } else {
                        props.handleDate([
                          date,
                          props.to_date,
                        ]);
                      }
                    }}
                    className="custom-date-input"
                    placeholderText="DD/MM/YYYY"
                    dateFormat="d MMM yyyy"
                    maxDate={undefined}
                  />

                  <CalendarDays size={18} className="date-picker-icon" />

                </div>
              </div>


              {/* To Date */}
              <div className="d-flex flex-column">
                <label className="filter-label mb-1">To Date</label>

                <div className="right-menu-header-date-picker mb-1">
                  <DatePicker
                    renderCustomHeader={renderCalendarHeader}
                    selected={
                      props.to_date
                        ? new Date(props.to_date)
                        : null
                    }
                    onChange={(date: Date | null) => {
                      if (
                        props.from_date &&
                        date &&
                        new Date(props.from_date) > new Date(date)
                      ) {
                        toast.error(
                          "To Date cannot be less than From Date"
                        );
                      } else {
                        props.handleDate([
                          props.from_date,
                          date,
                        ]);
                      }
                    }}
                    className="custom-date-input"
                    placeholderText="DD/MM/YYYY"
                    dateFormat="d MMM yyyy"
                    minDate={
                      props.from_date
                        ? new Date(props.from_date)
                        : undefined
                    }
                  />
                  <CalendarDays size={18} className="date-picker-icon" />

                </div>
              </div>


              {/* Apply Button */}
              <button
                className="dashboard-wrapper__apply-btn mb-1"
                onClick={handleApply}
              >
                Apply
              </button>

            </div>

          ) : (
            <CommonDateRange
              from_date={props.from_date}
              to_date={props.to_date}
              handleDate={props.handleDate}
              handleCancelDate={props.handleCancelDate}
              handleSubmitDate={props.handleSubmitDate}
              datePickerRef={props.datePickerRef}
            />

          ))}
        {getValue(props, `mappedTaskSCExecutor`, false) && (
          <h6
            className="mx-3 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/activities/self-compliance/my-task/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}
        {getValue(props, `internalmappedTasksFH`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/repository/internal-mapping/function-head/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {getValue(props, `internalmappedTasksE`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/repository/internal-mapping/evaluator/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {getValue(props, `mappedTasksFH`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/repository/mapped-checkpoint/function-head/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {getValue(props, `mappedTasksEvaluator`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/repository/mapped-checkpoint/evaluator/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {getValue(props, `selfComplianceMappedTasksEvaluator`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/activities/self-compliance/pending-approval/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {getValue(props, `internalComplianceMappedTasksExecutor`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/activities/internal-compliance/my-task/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {getValue(props, `internalComplianceMappedTasksEvaluator`, false) && (
          <h6
            className="me-2 mar-left-8 header_text__blue cursor-pointer"
            onClick={() =>
              navigate(
                `/activities/internal-compliance/pending-approval/my-tasks?${mainQueryRequest}`,
              )
            }
          >
            Mapped Tasks
          </h6>
        )}

        {props.add == "true" &&
          (getValue(props, `isAdd`, false) ? (
            <>
              <ReactTooltip id="subHeaderAdd" effect="solid" place="bottom">
                Add
              </ReactTooltip>
              <div
                className="add-filter-wrapper__add-icon d-flex cursor-pointer align-items-center justify-content-center"
                onClick={() => props.handleAddFun()}
                data-tip
                data-for="subHeaderAdd"
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
                  <path
                    d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                    fill="#ffffff"
                  />
                </svg>
              </div>
            </>
          ) : (
            <>
              <ReactTooltip id="subHeaderAdd" effect="solid" place="bottom">
                Add
              </ReactTooltip>
              <NavLink
                to={`${props.route}`}
                className=""
                data-tip
                data-for="subHeaderAdd"
              >
                <div className="add-filter-wrapper__add-icon d-flex align-items-center justify-content-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    width="24"
                  >
                    <path
                      d="M11 19V13H5V11H11V5H13V11H19V13H13V19Z"
                      fill="#ffffff"
                    />
                  </svg>
                </div>
              </NavLink>
            </>
          ))}

        {getValue(props, `monthYear`, "") && (
          <div className="right_subheader_monthYear_picker">
            <CalenderDropdown
              value={props.value}
              onChange={props.onChange}
              handleSubmitDate={props.handleSubmitDate}
              isApplyButtonRequied={isApplyButtonRequied}
              isYear={isYear}
            />
          </div>
        )}
      </div>

      <div
        className={`sub-header-icons-holder d-flex  ${getValue(props, `lineSeperator`, false)
          ? "sub-header-icons-left-line-seperator"
          : ""
          }`}
      >
        {!isCompactActions && getValue(props, `isSearch`, false) && (
          <>
            <ReactTooltip id="subHeaderSearch" effect="solid" place="bottom">
              Search
            </ReactTooltip>
            <div className="floatable-search-container">
              <input
                className="search expandright"
                id="searchright"
                type="search"
                name="search_text"
                onChange={handleChangeSearch}
                value={searchText}
                placeholder="Search"
              />
              <label
                className="searchbutton"
                htmlFor="searchright"
                data-tip
                data-for="subHeaderSearch"
              >
                <SearchSubheaderSvgComponent />
              </label>
              <div className="search-overlay"></div>
            </div>
          </>
        )}

        {!isCompactActions && getValue(props, `calendarViewSCExecutorTask`, false) && (
          <>
            <ReactTooltip
              id="calendarViewSCExecutorTask"
              effect="solid"
              place="bottom"
            >
              Calendar View
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="calendarViewSCExecutorTask"
              onClick={() => {
                if (getValue(props, `compliance_task_ids.length`, 0) > 0) {
                  props.removeCalenderList();
                }
                props.handleNavigateCalenderView();
              }}
            >
              <CalendarViewSubheaderSvgComponent />
            </button>
          </>
        )}

        {!isCompactActions && getValue(props, `calendarViewICExecutorTask`, false) && (
          <>
            <ReactTooltip
              id="calendarViewICExecutorTask"
              effect="solid"
              place="bottom"
            >
              Calendar View
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="calendarViewICExecutorTask"
              onClick={() => {
                if (getValue(props, `compliance_task_ids.length`, 0) > 0) {
                  props.removeCalenderList();
                }
                props.handleNavigateCalenderView();
              }}
            >
              <CalendarViewSubheaderSvgComponent />
            </button>
          </>
        )}

        {!isCompactActions && getValue(props, `calendarViewActivitiesLicense`, false) && (
          <>
            <ReactTooltip
              id="calendarViewActivitiesLicense"
              effect="solid"
              place="bottom"
            >
              Calendar View
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="calendarViewActivitiesLicense"
              onClick={() => {
                if (getValue(props, `compliance_task_ids.length`, 0) > 0) {
                  props.removeCalenderList();
                }
                props.handleNavigateCalenderView();
              }}
            >
              <CalendarViewSubheaderSvgComponent />
            </button>
          </>
        )}

        {!isCompactActions && getValue(props, `smartFilter`, false) && (
          <>
            <ReactTooltip id="subHeaderFilter" effect="solid" place="bottom">
              Filter
            </ReactTooltip>
            <span className="filter-icons-button">
              <button
                className="icons-btn"
                data-tip
                data-for="subHeaderFilter"
                onClick={props.handleFilter}
              >
                <FilterSubheaderSvgComponent />
              </button>
              {props.selectedFilterCount > 1 ? (
                <span className="filter-count">
                  {props.selectedFilterCount}
                </span>
              ) : (
                ""
              )}
            </span>
          </>
        )}
        {getValue(props, `activeStatusFilter`, false) && (
          <div className="active-status-filter-dropdown-container">
            <button
              className="icons-btn"
              data-tip
              data-for="activeStatusFilterTooltip"
            >
              <FilterSubheaderSvgComponent />
            </button>
            <ReactTooltip id="activeStatusFilterTooltip" effect="solid" place="bottom">
              Status Filter
            </ReactTooltip>
            <div className="active-status-filter-dropdown-menu">
              <div
                className={`active-status-filter-dropdown-item ${(!params.is_active || params.is_active === "all") ? "active" : ""}`}
                onClick={() => handleChangeActiveStatusFilter("all")}
              >
                All
              </div>
              <div
                className={`active-status-filter-dropdown-item ${params.is_active === "true" ? "active" : ""}`}
                onClick={() => handleChangeActiveStatusFilter("true")}
              >
                Active
              </div>
              <div
                className={`active-status-filter-dropdown-item ${params.is_active === "false" ? "active" : ""}`}
                onClick={() => handleChangeActiveStatusFilter("false")}
              >
                Inactive
              </div>
            </div>
          </div>
        )}
        {getValue(props, `changeOwner`, false) && (
          <>
            <ReactTooltip
              id="subHeaderChangeOwner"
              effect="solid"
              place="bottom"
            >
              Change Owner
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="subHeaderChangeOwner"
              onClick={props.handleModal}
            >
              <ChangeOwnerSubheaderSvgComponent />
            </button>
          </>
        )}

        {!isCompactActions && getValue(props, `downloadSelfComplianceReport`, false) && (
          <>
            <ReactTooltip id="subHeaderDownload" effect="solid" place="bottom">
              Download
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="subHeaderDownload"
              onClick={
                props.downloadLoading
                  ? null
                  : props.handleDownloadSelfComplianceReport
              }
            >
              {props.downloadLoading ? (
                <Spinner size="sm" color="secondary">
                  Loading...
                </Spinner>
              ) : (
                <DownloadSubheaderSvgComponent />
              )}
            </button>
          </>
        )}

        {!isCompactActions && getValue(props, `downloadLegacyTaskReport`, false) && (
          <>
            <ReactTooltip
              id="subHeaderDownloadLT"
              effect="solid"
              place="bottom"
            >
              Download
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="subHeaderDownloadLT"
              onClick={
                props.downloadLoading
                  ? null
                  : props.handleDownloadLegacyTaskReport
              }
            >
              {props.downloadLoading ? (
                <Spinner size="sm" color="secondary">
                  Loading...
                </Spinner>
              ) : (
                <DownloadSubheaderSvgComponent />
              )}
            </button>
          </>
        )}

        {!isCompactActions && getValue(props, `downloadAssignTask`, false) && (
          <>
            <ReactTooltip
              id="subHeaderDownloadAssignTask"
              effect="solid"
              place="bottom"
            >
              Download
            </ReactTooltip>
            <button
              className="icons-btn"
              data-tip
              data-for="subHeaderDownloadAssignTask"
              onClick={
                props.downloadLoading ? null : props.handleDownload
              }
            >
              {props.downloadLoading ? (
                <Spinner size="sm" color="secondary">
                  Loading...
                </Spinner>
              ) : (
                <DownloadSubheaderSvgComponent />
              )}
            </button>
          </>
        )}
        {!isCompactActions && props.vendorBulkDownload && (
          <>
            <ReactTooltip id="subHeaderDownload" effect="solid" place="bottom">
              Download
            </ReactTooltip>
            <UncontrolledDropdown>
              <DropdownToggle
                className="icons-btn p-0"
                data-tip
                data-for="subHeaderDownload"
              >
                <DownloadSubheaderSvgComponent />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={
                    props.downloadLoading
                      ? null
                      : props.handleDownloadVendorReport
                  }
                >
                  Vendor
                </DropdownItem>

                <DropdownItem
                  onClick={
                    props.downloadLoading
                      ? null
                      : props.handleDownloadVendorUserReport
                  }
                >
                  Vendor User Report
                </DropdownItem>

                <DropdownItem
                  onClick={
                    props.downloadLoading
                      ? null
                      : props.handleDownloadVendorEmailMappingReport
                  }
                >
                  Email Mapping
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </>
        )}

        {!isCompactActions && props.vendorComplianceBulkDownload && (
          <>
            <ReactTooltip id="subHeaderDownload" effect="solid" place="bottom">
              Download
            </ReactTooltip>
            <UncontrolledDropdown>
              <DropdownToggle
                className="icons-btn p-0"
                data-tip
                data-for="subHeaderDownload"
              >
                <DownloadSubheaderSvgComponent />
              </DropdownToggle>
              <DropdownMenu>
                {/* Vendor Checkpoint Normal Label with Hover to show PDF/Excel icons */}
                <DropdownItem
                  className="d-flex align-items-center justify-content-between"
                  style={{ cursor: "default" }}
                  onMouseEnter={() => setShowCheckpointOptions(true)}
                  onMouseLeave={() => setShowCheckpointOptions(false)}
                  onClick={(e) => e.preventDefault()}
                >
                  <span>Vendor Checkpoint</span>

                  {showCheckpointOptions && (
                    <div className="d-flex align-items-center gap-2 ms-3" onClick={(e) => e.stopPropagation()}>
                      <img
                        src="/pdf-svgrepo-com.svg"
                        alt="Download PDF"
                        title="Download PDF"
                        width={18}
                        height={18}
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!props.downloadLoading) {
                            props.handleDownloadSelfComplianceReport(DownloadTypeEnum.PDF);
                          }
                        }}
                      />

                      <img
                        src="/excel-svgrepo-com.svg"
                        alt="Download Excel"
                        title="Download Excel"
                        width={18}
                        height={18}
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!props.downloadLoading) {
                            props.handleDownloadSelfComplianceReport(DownloadTypeEnum.EXCEL);
                          }
                        }}
                      />
                    </div>
                  )}
                </DropdownItem>

                <DropdownItem
                  onClick={
                    props.downloadLoading
                      ? undefined
                      : props.handleDownloadVendorComplianceAuditScore
                  }
                >
                  Vendor Audit Score
                </DropdownItem>

                <DropdownItem
                  onClick={
                    props.downloadLoading
                      ? null
                      : props.handleDownloadVendorwiseAuditScore
                  }
                >
                  Vendorwise Audit Score
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </>
        )}
        {!isCompactActions && props.commonUpload && (
          <BulkUploadDropdown
            url={getValue(props, `downloadURL`, "")}
            dropdownOptions={getValue(props, `dropdownOptions`, [])}
          />
        )}
        {!isCompactActions && props.commonViewLogs && (
          <BulkViewLogs
            url={getValue(props, `downloadURL`, "")}
            dropdownOptions={getValue(props, `dropdownOptions`, [])}
          />
        )}

        {!isCompactActions && props.commonViewLogsRepositoryMC && (
          <BulkViewLogs
            url={getValue(props, `downloadURL`, "")}
            dropdownOptions={getValue(props, `dropdownOptionsRepositoryMC`, [])}
          />
        )}

        {!isCompactActions && props.commonViewLogsRepositoryLegacyTask && (
          <BulkViewLogs
            url={getValue(props, `downloadURL`, "")}
            dropdownOptions={getValue(
              props,
              `dropdownOptionsRepositoryLegacyTask`,
              [],
            )}
          />
        )}
        {!isCompactActions &&
          getValue(props, `viewDownloadedSelfComplianceReports`, false) && (
            <>
              <ReactTooltip id="subHeaderViewLogs" effect="solid" place="bottom">
                View Logs
              </ReactTooltip>
              <button
                className="icons-btn"
                data-tip
                data-for="subHeaderViewLogs"
                onClick={() => props.handleNavigateLogs()}
              >
                <LogSubheaderSvgComponent />
              </button>
            </>
          )}

        {isCompactActions && (
          <UncontrolledDropdown className="right-menu-more-dropdown">
            <DropdownToggle
              className="icons-btn right-menu-more-toggle"
              aria-label="More actions"
            >
              <EllipsisVertical size={18} />
            </DropdownToggle>
            <DropdownMenu className="right-menu-more-dropdown__menu">
              {getValue(props, `isSearch`, false) && (
                <div
                  className="right-menu-more-dropdown__search"
                  onClick={(event) => event.stopPropagation()}
                >
                  <div className="right-menu-more-dropdown__label">Search</div>
                  <input
                    className="right-menu-more-dropdown__input"
                    type="search"
                    name="search_text"
                    onChange={handleChangeSearch}
                    value={searchText}
                    placeholder="Search"
                  />
                </div>
              )}

              {getValue(props, `calendarViewSCExecutorTask`, false) && (
                <DropdownItem
                  className="right-menu-more-dropdown__item"
                  onClick={() => {
                    if (getValue(compliance_task_ids, `length`, 0) > 0) {
                      removeCalenderList();
                    }
                    props.handleNavigateCalenderView();
                  }}
                >
                  <CalendarViewSubheaderSvgComponent />
                  <span>Calendar View</span>
                </DropdownItem>
              )}

              {getValue(props, `smartFilter`, false) && (
                <DropdownItem
                  className="right-menu-more-dropdown__item"
                  onClick={props.handleFilter}
                >
                  <FilterSubheaderSvgComponent />
                  <span>Filter</span>
                  {props.selectedFilterCount > 1 ? (
                    <span className="right-menu-more-dropdown__badge">
                      {props.selectedFilterCount}
                    </span>
                  ) : null}
                </DropdownItem>
              )}

              {getValue(props, `downloadSelfComplianceReport`, false) && (
                <DropdownItem
                  className="right-menu-more-dropdown__item"
                  onClick={
                    props.downloadLoading
                      ? null
                      : props.handleDownloadSelfComplianceReport
                  }
                >
                  {props.downloadLoading ? (
                    <Spinner size="sm" color="secondary" />
                  ) : (
                    <DownloadSubheaderSvgComponent />
                  )}
                  <span>Download</span>
                </DropdownItem>
              )}

              {getValue(props, `viewDownloadedSelfComplianceReports`, false) && (
                <DropdownItem
                  className="right-menu-more-dropdown__item"
                  onClick={() => props.handleNavigateLogs()}
                >
                  <LogSubheaderSvgComponent />
                  <span>View Logs</span>
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        )}
      </div>
    </>
  );
}